export enum FixedPriceType {
  VENDOR_MARKUP_PRICE = "v$",
  SELL_PRICE = "s$",
  SELL_PERCENT_PROFIT = "s%",
}

const FIXED_PRICE_TYPE_BY_ALIAS: Record<string, FixedPriceType> = {
  "v$": FixedPriceType.VENDOR_MARKUP_PRICE,
  "s$": FixedPriceType.SELL_PRICE,
  "s%": FixedPriceType.SELL_PERCENT_PROFIT,
  // Legacy / mistaken enum-key strings stored in varchar columns.
  VENDOR_MARKUP_PRICE: FixedPriceType.VENDOR_MARKUP_PRICE,
  SELL_PRICE: FixedPriceType.SELL_PRICE,
  SELL_PERCENT_PROFIT: FixedPriceType.SELL_PERCENT_PROFIT,
};

/**
 * Coerce DB/API fixedPriceType to the canonical enum value (`v$` / `s$` / `s%`).
 * Some rows store TypeScript enum member names instead of values.
 */
export function normalizeFixedPriceType(
  raw: unknown,
  fallback: FixedPriceType = FixedPriceType.SELL_PERCENT_PROFIT
): FixedPriceType {
  if (raw == null) return fallback;
  const key = String(raw).trim();
  if (!key) return fallback;
  return FIXED_PRICE_TYPE_BY_ALIAS[key] ?? fallback;
}
